export default "__VITE_ASSET__usbtxXSl__"